export const formGroup = {
  kodeKas: { value: "", mandatory: true },
  kodeCabang: { value: null, mandatory: true },
  name: { value: "", mandatory: true },
  status: { value: "INACTIVE" },
};
